import React from 'react';
import ReactDOM from 'react-dom';

import RootContainer from './modules/root';

export default () =>
  ReactDOM.render(<RootContainer />, document.getElementById('reactContainer'));
